import { useNotification } from "../contexts/NotificationContext";
import axios from "./axiosInstance";

const API_URL = import.meta.env.VITE_API_URL;

// Define a list of endpoints to exclude
const excludedEndpoints = [
    "CourseAttempt",
    "Feedback", 
    "AdminAuth/login", 
    "AdminAuth/mfa/enrollment",
    "AdminAuth/mfa/enrollment/confirm",
    "AdminAuth/mfa/verify",
    "AdminAuth/refresh",
    "AdminAuth/password/reset",
    "AdminAuth/password/resetLink",
    "AdminAuth/password/reset/validate"];
const unauthenticatedAuthEndpoints = [
    "adminauth/login",
    "adminauth/mfa/enrollment",
    "adminauth/mfa/enrollment/confirm",
    "adminauth/mfa/verify",
    "adminauth/refresh"
];

const setupInterceptors = (getAuthContext, getNotificationContext) => {

    // Remove all request interceptors
    axios.interceptors.request.handlers = [];
    // Remove all response interceptors
    axios.interceptors.response.handlers = [];

    /**
     * This interceptor's job is to attach the bearer token to every request that requires it so that we don't have
     * to do that explicitly for every service call.
     */
    axios.interceptors.request.use(
        (config) => {
            return config;
        },
        (error) => {
            console.error(error);
            return Promise.reject(error);
        }
    );

    /**
     * This interceptor's responsibility is to detect an expired JWT token and to request a new one. This will be
     * completely transparent to the application. The failed call will then be retried with the new token
     */
    axios.interceptors.response.use(
        (res) => {
            const originalConfig = res.config;
            console.log(originalConfig);
            //if POST and successful
            if (originalConfig.method === "put" && res.status === 200 && !excludedEndpoints.includes(originalConfig.url)) {
                //show nofication that save is successful
                const notification = getNotificationContext();
                notification.showInfo("Updated!");
            }
            // exclude endpoint "/attempts"
            if (originalConfig.method === "post" && res.status === 200 && !excludedEndpoints.includes(originalConfig.url)) {
                //show nofication that save is successful
                const notification = getNotificationContext();
                notification.showInfo("Created!");
            }
            if (originalConfig.method === "delete" && res.status === 200 && !excludedEndpoints.includes(originalConfig.url)) {
                //show nofication that save is successful
                const notification = getNotificationContext();
                notification.showInfo("Deleted!");
            }
            
            return res;
        },
        async (err) => {
            const notification = getNotificationContext();
            const authContext = getAuthContext();
            console.error(err);
            const originalConfig = err.config;
            if (err.response.status == 400 || err.response.status == 500){
                var message = "An error occurred. Please try again."
                if (err.response?.data?.error?.errorDescription !== null ){
                    message = err.response.data.error.errorDescription
                } else if (err.message !== null){
                    message = err.message;
                } else {
                    message ="An error has occurred: " + JSON.stringify(err);
                }
                console.log("about to show notification");
                notification.showError(message);    
                console.log(message);
            }
            const reqUrl = originalConfig.url.toLowerCase();
            console.log("REQ URL: " + reqUrl);
            if (!unauthenticatedAuthEndpoints.includes(reqUrl) && err.response) {
                // Access Token was expired so lets try to refresh it
                if (err.response.status === 401 && !originalConfig._retry) {
                    originalConfig._retry = true;
                    const newJwtToken = await authContext.refreshToken();
                    console.log("old token", authContext.authentication.jwtToken);
                    console.log("new token", newJwtToken);
                    originalConfig.headers.Authorization = `Bearer ${newJwtToken}`;
                    return axios(originalConfig);
                }
            }
            if (err.response && reqUrl === "adminauth/refresh"){
                console.log("COULD NOT REFRESH... LOGGING OUT")
                authContext.logout();
            }
            return Promise.reject({err,message:err.response?.data?.error?.errorDescription});
        }
    );
};

export default setupInterceptors;
